import React, { useState, useEffect } from 'react';
import './Cart.css';

let updateCounter = 0;
function CartCounter({ counter }) {
  const [blink, setBlink] = useState(false);
  useEffect(() => {
    updateCounter++;
    if (updateCounter >= 3) {
      setBlink(true);
      setTimeout(() => {
        setBlink(false);
      }, 5000);
    }
  }, [counter]);

  return <span className={`cart-counter ${blink && 'blink'} ${(counter <= 0 || counter === null) && 'none'} `}>{counter}</span>;
}

export default CartCounter;
